module.exports = __webpack_public_path__ + "static/media/wand4.054a7f5d.png";